import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { LogoutButton } from '@/components/auth/logout-button'
import { RoleGuard } from '@/components/auth/role-guard'
import { BrandLogo } from '@/components/brand-logo'
import { ThemeToggle } from '@/components/theme-toggle'

export const Route = createFileRoute('/coach')({
  component: CoachLayout,
})

function CoachLayout() {
  return (
    <RoleGuard allowedRoles={['coach']}>
      <div className="min-h-dvh">
        <header className="flex items-center justify-between gap-4 border-b px-4 py-3">
          <div className="flex min-w-0 items-center gap-2.5">
            <BrandLogo />
            <span aria-hidden="true" className="text-muted-foreground/40">
              ·
            </span>
            <span className="truncate text-sm text-muted-foreground">Кабинет тренера</span>
          </div>
          <div className="flex items-center gap-1">
            <Link
              to="/coach/system-prompt"
              className="hidden rounded-md px-2 py-1 text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground sm:inline-block"
              activeProps={{ className: 'text-foreground' }}
            >
              Системный промт
            </Link>
            <ThemeToggle />
            <LogoutButton />
          </div>
        </header>
        <Outlet />
      </div>
    </RoleGuard>
  )
}
